import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import { purpleMui } from "@ryde/theme";

export const EntityChipStyled = styled.a.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ai-advisor-entity-chip",
})`
  display: inline;
  color: ${purpleMui._700};
  text-decoration: none;
  border-bottom: 1px dotted ${purpleMui._400};
  cursor: pointer;
  /*
   * The reason this element exists at all. "Name [ID]" mixes Hebrew with Latin digits and
   * brackets, all of which are bidi-neutral, so the id routinely renders on the wrong side
   * of the phrase. Isolating the run fixes the display without touching the string.
   */
  unicode-bidi: isolate;

  &:hover {
    color: ${purpleMui._900};
    border-bottom-style: solid;
  }
`;

export const RuleStyled = styled.hr.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ai-advisor-rule",
})`
  /* The global reset zeroes margins, which would leave the line touching the text. */
  margin: 16px 0;
  border: none;
  /* The approved separator shade; no greyMui step matches it (_300 is lighter, _400 darker). */
  border-top: 1px solid #c8c8c8;
`;
